import {
  Component,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BrandsEnum } from '../../../_enums/brands.enum';
import { GetElementUtils } from '../../../utils/getElement.utils';
import { SdLibConfig } from '../../../sd-lib-config';
import { ThemesEnum } from '../../../_enums/themes.enum';

@Component({
  selector: '[sd-loader]',
  templateUrl: './loader.component.html',
  standalone: true,
  imports: [TranslateModule]
})
export class SdLoaderComponent implements OnChanges {
  @Input()
  brand: BrandsEnum;

  @Input()
  loading = true;

  @Input()
  global = false;

  @Input()
  class: string; // override the standard class attr with a new one.
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.loaderTheme ? 'is-theme-' + this.loaderTheme : '',
      this.global ? 'is-global' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  loaderTheme: ThemesEnum;
  getElementUtils = GetElementUtils;

  constructor(
    private sdLibConfig: SdLibConfig,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    this.loaderTheme = this.sdLibConfig.get().loaderTheme;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      isPlatformBrowser(this.platformId) &&
      this.global &&
      changes['loading']
    ) {
      this.loaderTheme = this.sdLibConfig.get(this.brand).loaderTheme;

      const body = this.getElementUtils.byId('appWrapper', this.document.body);
      if (changes.loading.currentValue) {
        this.renderer.addClass(body, 'has-no-overflow');
      } else {
        if (body.classList.contains('has-no-overflow')) {
          this.renderer.removeClass(body, 'has-no-overflow');
        }
      }
    }
  }
}
